import { render, staticRenderFns } from "./QRs.vue?vue&type=template&id=12c9214e&lang=pug"
import script from "./QRs.vue?vue&type=script&lang=js"
export * from "./QRs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports